import {GET_OBJECT_SUCCESS} from "../../../../../apps/KpModule/actions/api";
import _ from "lodash";

const { generateFetchFieldListAction } = require('../../../../../apps/KpModule/actions/api')

export const contractualisation = {
    name: "bp4",
    object: "BusinessProject",
    category: {
        path: "projects",
        icon: 'briefcase'
    },
    step: "submitOffer",
    newable: false,
    removable: false,
    actions: [
        {method: 'PUT', name: 'validate', tKey: 'validate', accessIdPath: 'accessId'},
        {method: 'PUT', name: 'question', tKey: 'question', accessIdPath: 'accessId'},
        {method: 'PUT', name: 'lost', tKey: 'lost', accessIdPath: 'accessId'},
        {method: 'PUT', name: 'abandoned', tKey: 'abandoned', accessIdPath: 'accessId'},
    ],
    viewMap: {
        dt: [
            {path: "country", width: 200},
            {path: "customer", width: 200, initiallyNotVisible: true},
            {path: "typeOfOffer", width: 300, initiallyNotVisible: true},
            {path: "fullName", tKey: 'name', width: 500},
            {path: "description", type: 'richText', width: 300, initiallyNotVisible: true},
            {path: "responseMode", initiallyNotVisible: true},
            {path: "beginYear", initiallyNotVisible: true},
            {path: "expectedTurnOver", tooltip: true, width: 160},
            {path: "expectedContractCost", tooltip: true, width: 80},
            {path: "expectedContractMarginInPercent", width: 80},
            {path: "expectedNumberOfDays", tooltip: true, width: 80, initiallyNotVisible: true},
            {path: "effectiveOfferSubmissionDate", width: 150},
            {path: "estimatedResponseDate", width: 150, initiallyNotVisible: true},
            {path: "offerAcceptedDate", width: 150, initiallyNotVisible: true},
            {path: "signatureDate", width: 150, initiallyNotVisible: true},
            {path: "monitoringTeamMembers", tKey: "projectMonitors", display: "fullName", initiallyNotVisible: true},
            {path: "currentFunctions", width: 100},
            {path: "file", tKey: "FA"},

            {path: 'orangeStyledRow', hidden : true},
            {path: 'redStyledRow', hidden : true}
        ],
        form: {
            fields: [
                "identifier",
                {path: "country", writable: false, hidden: true},
                /*
                {
                    path: "country", tKey: "country", display: "fullInformations", writable: false,
                    filters: ["inUserTeam"],
                    subscriptions: {
                        onChange: (newValue, oldValue, {formInitialize, module, store}) => {
                            if (newValue && newValue.id) {
                                const dataCountry = {country: {id: newValue.id}}
                                store.dispatch(
                                    generateFetchFieldListAction(
                                        "m-I-bp4.BusinessProject_customer",
                                        store.getState,
                                        {data: dataCountry}
                                    )
                                )
                            } else {
                                store.dispatch(setFieldListOptions("e_customer", []))
                            }
                        }
                    }
                },

                 */
                {path: "name", writable: false, required: false},
                {path: "description", type: "richTextEditor", editable: false},
                {path: "developerPitches", tKey: "developerPitch", type: "richTextEditor", writable: false},
                {path: "beginYear", editable: false},
                {path: "customer", display: "codeNameRelation", required: true},
                {path: "estimatedTurnover", editable: false},
                "globalTurnover",
                {path: "resourceTypes", required: true},
                {path: "responseMode", writable: false, required: false},

                {path: "effectiveOfferSubmissionDate", required: true},
                {path: "estimatedResponseDate", required: true},
                "offerAcceptedDate",
                {path: "signatureDate"},
                {path: "beginningOfRealisationDate"},
                {path: "projectFunding", required: true},
                {path: "compensationModes", required: true},

                {path: "contractualSchema", required: true},
                {path: "needLocalStructure"},

                {path: "partners", filters: ["partners"], required: false},
                {path: "subcontractors", filters: ["subcontractors"], required: false},
                {path: "competitors", filters: ["competitors"], required: false},

                {path: "commercialTeamMember", display: "fullName", filters: ["commercialReferent"], required: true},
                {path: "technicalTeamMember", display: "fullName", filters: ["technicalReferent"], writable: false},
                {path: "monitoringTeamMembers", tKey: "projectMonitors", display: "fullName", filters: ["projectMonitor"]},
                {path: "projectManager", writable: false},
                {path: "projectTeam", type: "textarea", writable: false},

                "comments",
                "files",

                {path:"delegatedUsers", filters:["byCountry"], fieldPath: ["id", "userName", "firstName", "lastName", "email"], display: "userName"},

                {path: "delegatedUsersGetter", hidden: true},
                {path: "buttons", hidden: true},
                {path: "workflow", hidden: true},

                {path: "businessProject", hidden: true}
            ],
            onOpen: ({state, store}) => {
                const projectCountry = {country: state.edit.object.data.country}

                store.dispatch(
                    generateFetchFieldListAction(
                        "m-I-bp4.BusinessProject_delegatedUsers",
                        store.getState,
                        {data: projectCountry}
                    )
                )
            }
        }
    },
    actionSubscriptions: [
        {
            actionType: GET_OBJECT_SUCCESS,
            subscription: ({ module, store }) => {
                const state = store.getState()
                const delegatedUsers = _.get(state, 'edit.object.data.delegatedUsersGetter')
                const delegatedUsersField = module.viewMap.form.fields.find(field => field.id === "e_delegatedUsers")
                delegatedUsersField.setValue(delegatedUsers)
            }
        }
    ],
    filters: [
        "byTypeOfOffer",
        {query: () => ({"workflow.step": "submitOffer"})}
    ]
}
